// // import api from "./api";

// // export const gameService = {
// //   // Get current active round
// //   getCurrentRound: async () => {
// //     const response = await api.get("/game/current-round");
// //     return response.data;
// //   },

// //   // Place bet (PLAYER)
// //   placeBet: async (betData) => {
// //     const response = await api.post("/game/place-bet", betData);
// //     return response.data;
// //   },

// //   // Get bet history (PLAYER / ALL)
// //   getHistory: async () => {
// //     const response = await api.get("/game/history");
// //     return response.data;
// //   }
// // };

// // export default gameService;





// import api from "./api";

// export const gameService = {
//   getCurrentRound: async () => {
//     const response = await api.get("/game/current-round");
//     return response.data;
//   },

//   placeBet: async (betData) => {
//     const response = await api.post("/game/place-bet", betData);
//     return response.data;
//   },

//   placeBets: async (payload) => {
//     const response = await api.post("/game/place-bets", payload);
//     return response.data;
//   },

//   getHistory: async () => {
//     const response = await api.get("/game/history");
//     return response.data;
//   },

//   getRecentResults: async (limit = 10) => {
//     const response = await api.get(
//       `/game/recent-results?limit=${limit}`
//     );

//     return response.data;
//   }
// };

// export default gameService;





import api from "./api";

// ============================================================
// AUTH CONFIG FOR READ-ONLY GAME DATA
// ============================================================

const getReadOnlyAuthConfig = () => {
  const token =
    sessionStorage.getItem("computer_token") ||
    localStorage.getItem("computer_token") ||
    localStorage.getItem("token");

  if (token) {
    return {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
  }

  return {};
};

// ============================================================
// GAME SERVICE
// ============================================================

export const gameService = {
  // ----------------------------------------------------------
  // READ ONLY
  // Staff + Computer
  // ----------------------------------------------------------

  getCurrentRound: async () => {
    const response =
      await api.get(
        "/game/current-round",
        getReadOnlyAuthConfig()
      );

    return response.data;
  },

  getRecentResults: async (
    limit = 10
  ) => {
    const response =
      await api.get(
        `/game/recent-results?limit=${limit}`,
        getReadOnlyAuthConfig()
      );

    return response.data;
  },

  // ----------------------------------------------------------
  // EXISTING PLAYER-ONLY OPERATIONS
  // Computer Game UI must NOT call these.
  // ----------------------------------------------------------

  placeBet: async (betData) => {
    const response =
      await api.post(
        "/game/place-bet",
        betData,
        getReadOnlyAuthConfig()
      );

    return response.data;
  },

  placeBets: async (payload) => {
    const response =
      await api.post(
        "/game/place-bets",
        payload,
        getReadOnlyAuthConfig()
      );

    return response.data;
  },

  getHistory: async () => {
    const response =
      await api.get(
        "/game/history",
        getReadOnlyAuthConfig()
      );

    return response.data;
  }
};

export default gameService;